var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/star"
  }, /*#__PURE__*/React.createElement("g", {
    id: "star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.3895 5.2093L16.7995 8.0293C16.9895 8.4193 17.4995 8.7893 17.9295 8.8693L20.4795 9.2893C22.1095 9.5593 22.4895 10.7393 21.3195 11.9193L19.3295 13.9093C18.9995 14.2393 18.8095 14.8893 18.9195 15.3593L19.4895 17.8193C19.9395 19.7593 18.8995 20.5193 17.1895 19.4993L14.7995 18.0793C14.3695 17.8193 13.6495 17.8193 13.2195 18.0793L10.8295 19.4993C9.11945 20.5093 8.07945 19.7593 8.52945 17.8193L9.09945 15.3593C9.18945 14.8793 8.99945 14.2293 8.66945 13.8993L6.67945 11.9093C5.50945 10.7393 5.88945 9.5593 7.51945 9.2793L10.0695 8.8593C10.4995 8.7893 11.0095 8.4093 11.1995 8.0193L12.6095 5.1993C13.3795 3.6793 14.6195 3.6793 15.3895 5.2093Z",
    fill: "#6553F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8 5.75H2C1.59 5.75 1.25 5.41 1.25 5C1.25 4.59 1.59 4.25 2 4.25H8C8.41 4.25 8.75 4.59 8.75 5C8.75 5.41 8.41 5.75 8 5.75Z",
    fill: "#6553F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5 19.75H2C1.59 19.75 1.25 19.41 1.25 19C1.25 18.59 1.59 18.25 2 18.25H5C5.41 18.25 5.75 18.59 5.75 19C5.75 19.41 5.41 19.75 5 19.75Z",
    fill: "#6553F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3 12.75H2C1.59 12.75 1.25 12.41 1.25 12C1.25 11.59 1.59 11.25 2 11.25H3C3.41 11.25 3.75 11.59 3.75 12C3.75 12.41 3.41 12.75 3 12.75Z",
    fill: "#6553F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/starIcon.ffe147793c62047003c192ab83594d78.svg";
export { ForwardRef as ReactComponent };